import { Component, Inject } from '@angular/core';
import { CMSPortalService } from '../../shared/service/cms-portal.service';
import { Noticia } from '../../shared/model/noticia.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-conteudo-destaque-noticia',
  templateUrl: './destaqueNoticia.component.html',
  styleUrls: ['./destaqueNoticia.component.css']
})
export class DestaqueNoticiaComponent {

  public noticiaDestaque: Noticia;

  constructor(private service: CMSPortalService,
              private router: Router,
              @Inject('CMS_HOST') private host: string) {
    this.getDestaque();
  }

  getDestaque() {
    this.service.getDestaquesNoticias().subscribe(res => {
      const conteudo: Array<Noticia> = res.conteudo;
      this.noticiaDestaque = conteudo[0];
    });
  }

  buscaImagem(): string {
    const imagens = this.noticiaDestaque.imagens.sort((a, b) => a.capa > b.capa ? -1 : a.capa < b.capa ? 1 : 0);
    return this.host + this.noticiaDestaque.imagens[0].url;
  }

  abrirNoticia() {
    this.router.navigate(['/noticia', this.noticiaDestaque.id]);
  }
}
